// Email templates for SOVO Development
// Based on existing SOVO brand style

export const paymentReminderTemplate = ({
  customerName,
  apartmentCode,
  dueAmount,
  dueDate,
  installmentNumber,
  daysOverdue,
  contractNumber
}) => {
  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('pl-PL', {
      style: 'currency',
      currency: 'PLN'
    }).format(amount);
  };

  const urgencyLevel = daysOverdue > 30 ? 'high' : daysOverdue > 14 ? 'medium' : 'low';
  const urgencyColor = urgencyLevel === 'high' ? '#d32f2f' : urgencyLevel === 'medium' ? '#f57c00' : '#1976d2';
  const urgencyIcon = urgencyLevel === 'high' ? '🚨' : urgencyLevel === 'medium' ? '⚠️' : '📅';

  return {
    subject: `${urgencyIcon} Przypomnienie o płatności - Lokal ${apartmentCode} (${daysOverdue} dni po terminie)`,
    html: `
      <!DOCTYPE html>
      <html lang="pl">
      <head>
        <meta charset="utf-8">
        <meta name="viewport" content="width=device-width, initial-scale=1.0">
        <title>Przypomnienie o płatności - SOVO Development</title>
        <style>
          body {
            margin: 0;
            padding: 0;
            font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Helvetica Neue', Arial, sans-serif;
            line-height: 1.6;
            color: #333333;
            background-color: #f5f5f5;
          }
          .email-container {
            max-width: 600px;
            margin: 0 auto;
            background-color: #ffffff;
          }
          .header {
            background-color: #ffffff;
            padding: 25px 20px;
            text-align: center;
            border-bottom: 1px solid #e5e5e5;
          }
          .content {
            padding: 35px 30px;
          }
          .greeting {
            margin: 0 0 20px 0;
            font-size: 22px;
            font-weight: 600;
            color: #7A0C2E;
          }
          .text-block {
            margin: 0 0 20px 0;
            font-size: 15px;
            color: #555555;
            line-height: 1.7;
          }
          .warning-box {
            background-color: ${urgencyLevel === 'high' ? '#ffebee' : urgencyLevel === 'medium' ? '#fff8e1' : '#e3f2fd'};
            border-left: 4px solid ${urgencyColor};
            padding: 18px 20px;
            margin: 25px 0;
            border-radius: 4px;
          }
          .warning-box p {
            margin: 0;
            font-size: 15px;
            color: ${urgencyColor};
            line-height: 1.6;
            font-weight: 600;
          }
          .payment-details {
            background-color: #f9f9f9;
            border-radius: 8px;
            padding: 25px;
            margin: 25px 0;
          }
          .detail-row {
            display: flex;
            justify-content: space-between;
            margin-bottom: 12px;
            padding-bottom: 8px;
            border-bottom: 1px solid #e0e0e0;
          }
          .detail-row:last-child {
            border-bottom: none;
            margin-bottom: 0;
            font-weight: 600;
            font-size: 16px;
          }
          .detail-label {
            font-weight: 500;
            color: #7A0C2E;
          }
          .detail-value {
            font-weight: 600;
            color: #333333;
          }
          .bank-details {
            background-color: #f0f8ff;
            border: 1px solid #2196f3;
            border-radius: 8px;
            padding: 20px;
            margin: 25px 0;
          }
          .bank-title {
            margin: 0 0 15px 0;
            font-size: 16px;
            font-weight: 600;
            color: #1976d2;
          }
          .bank-info {
            margin: 8px 0;
            font-size: 14px;
            color: #555555;
          }
          .bank-number {
            font-family: 'Courier New', monospace;
            font-weight: 600;
            background-color: #ffffff;
            padding: 8px;
            border-radius: 4px;
            border: 1px solid #e0e0e0;
          }
          .footer {
            background-color: #f5f5f5;
            padding: 25px 30px;
            text-align: center;
            border-top: 1px solid #e5e5e5;
          }
          .footer p {
            margin: 0 0 5px 0;
            font-size: 12px;
            color: #888888;
          }
        </style>
      </head>
      <body>
        <div class="email-container">
          <div class="header">
            <img src="https://sovozmianylokatorskie-xhjm5qczqq-ew.a.run.app/sovo_logo.png" alt="SOVO Development" style="height: 50px; width: auto; margin: 0 auto; display: block;">
          </div>

          <div class="content">
            <h2 class="greeting">Witaj ${customerName}!</h2>

            <div class="warning-box">
              <p>${urgencyIcon} <strong>Przypomnienie o zaległej płatności</strong></p>
            </div>

            <p class="text-block">
              Informujemy, że płatność za lokal <strong>${apartmentCode}</strong> przekroczyła termin płatności o <strong>${daysOverdue} dni</strong>.
            </p>

            <div class="payment-details">
              <div class="detail-row">
                <span class="detail-label">Lokal:</span>
                <span class="detail-value">${apartmentCode}</span>
              </div>
              <div class="detail-row">
                <span class="detail-label">Numer umowy:</span>
                <span class="detail-value">${contractNumber}</span>
              </div>
              <div class="detail-row">
                <span class="detail-label">Rata:</span>
                <span class="detail-value">${installmentNumber}</span>
              </div>
              <div class="detail-row">
                <span class="detail-label">Termin płatności:</span>
                <span class="detail-value">${dueDate}</span>
              </div>
              <div class="detail-row">
                <span class="detail-label">Dni przeterminowania:</span>
                <span class="detail-value" style="color: ${urgencyColor};">${daysOverdue} dni</span>
              </div>
              <div class="detail-row">
                <span class="detail-label">Kwota do zapłaty:</span>
                <span class="detail-value" style="color: ${urgencyColor}; font-size: 18px;">${formatCurrency(dueAmount)}</span>
              </div>
            </div>

            <div class="bank-details">
              <h3 class="bank-title">💳 Dane do przelewu</h3>
              <div class="bank-info">
                <strong>Nazwa odbiorcy:</strong> SOVO Development Sp. z o.o.
              </div>
              <div class="bank-info">
                <strong>Numer konta:</strong>
                <div class="bank-number">12 3456 7890 1234 5678 9012 3456</div>
              </div>
              <div class="bank-info">
                <strong>Tytuł przelewu:</strong> ${contractNumber} - Rata ${installmentNumber} - ${apartmentCode}
              </div>
            </div>

            <p class="text-block">
              <strong>Prosimy o niezwłoczną regulację zaległej płatności.</strong>
              ${urgencyLevel === 'high' ? 'W przypadku dalszego opóźnienia będziemy zmuszeni podjąć odpowiednie kroki prawne.' : ''}
            </p>

            <p class="text-block">
              W przypadku pytań lub problemów z płatnością, prosimy o natychmiastowy kontakt z naszym działem finansowym.
            </p>

            <p class="text-block">
              Z poważaniem,<br>
              <strong>Dział Finansowy SOVO Development</strong>
            </p>
          </div>

          <div class="footer">
            <p>Wiadomość automatyczna z systemu SOVO Development</p>
            <p>Kontakt: finanse@sovo.dev | Tel: +48 XXX XXX XXX</p>
          </div>
        </div>
      </body>
      </html>
    `,
    text: `
Witaj ${customerName}!

${urgencyIcon} PRZYPOMNIENIE O ZALEGŁEJ PŁATNOŚCI

Informujemy, że płatność za lokal ${apartmentCode} przekroczyła termin płatności o ${daysOverdue} dni.

SZCZEGÓŁY PŁATNOŚCI:
- Lokal: ${apartmentCode}
- Numer umowy: ${contractNumber}
- Rata: ${installmentNumber}
- Termin płatności: ${dueDate}
- Dni przeterminowania: ${daysOverdue} dni
- Kwota do zapłaty: ${formatCurrency(dueAmount)}

DANE DO PRZELEWU:
Nazwa odbiorcy: SOVO Development Sp. z o.o.
Numer konta: 12 3456 7890 1234 5678 9012 3456
Tytuł przelewu: ${contractNumber} - Rata ${installmentNumber} - ${apartmentCode}

Prosimy o niezwłoczną regulację zaległej płatności.
${urgencyLevel === 'high' ? 'W przypadku dalszego opóźnienia będziemy zmuszeni podjąć odpowiednie kroki prawne.' : ''}

W przypadku pytań lub problemów z płatnością, prosimy o natychmiastowy kontakt z naszym działem finansowym.

Z poważaniem,
Dział Finansowy SOVO Development

---
Wiadomość automatyczna z systemu SOVO Development
Kontakt: finanse@sovo.dev | Tel: +48 XXX XXX XXX
    `
  };
};

export const paymentDueTemplate = ({
  customerName,
  apartmentCode,
  dueAmount,
  installmentNumber,
  contractNumber,
  stageNumber,
  paymentDueDate
}) => {
  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('pl-PL', {
      style: 'currency',
      currency: 'PLN'
    }).format(amount);
  };

  const today = new Date().toLocaleDateString('pl-PL');
  const formattedPaymentDueDate = paymentDueDate
    ? new Date(paymentDueDate).toLocaleDateString('pl-PL')
    : today;

  return {
    subject: `📢 Płatność wymagana - Lokal ${apartmentCode} - Zakończono etap ${stageNumber}`,
    html: `
      <!DOCTYPE html>
      <html lang="pl">
      <head>
        <meta charset="utf-8">
        <meta name="viewport" content="width=device-width, initial-scale=1.0">
        <title>Płatność wymagana - SOVO Development</title>
        <style>
          body {
            margin: 0;
            padding: 0;
            font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Helvetica Neue', Arial, sans-serif;
            line-height: 1.6;
            color: #333333;
            background-color: #f5f5f5;
          }
          .email-container {
            max-width: 600px;
            margin: 0 auto;
            background-color: #ffffff;
          }
          .header {
            background-color: #ffffff;
            padding: 25px 20px;
            text-align: center;
            border-bottom: 1px solid #e5e5e5;
          }
          .content {
            padding: 35px 30px;
          }
          .greeting {
            margin: 0 0 20px 0;
            font-size: 22px;
            font-weight: 600;
            color: #7A0C2E;
          }
          .text-block {
            margin: 0 0 20px 0;
            font-size: 15px;
            color: #555555;
            line-height: 1.7;
          }
          .info-box {
            background-color: #e3f2fd;
            border-left: 4px solid #1976d2;
            padding: 18px 20px;
            margin: 25px 0;
            border-radius: 4px;
          }
          .info-box p {
            margin: 0;
            font-size: 15px;
            color: #1565c0;
            line-height: 1.6;
            font-weight: 600;
          }
          .payment-details {
            background-color: #f9f9f9;
            border-radius: 8px;
            padding: 25px;
            margin: 25px 0;
          }
          .detail-row {
            display: flex;
            justify-content: space-between;
            margin-bottom: 12px;
            padding-bottom: 8px;
            border-bottom: 1px solid #e0e0e0;
          }
          .detail-row:last-child {
            border-bottom: none;
            margin-bottom: 0;
            font-weight: 600;
            font-size: 16px;
          }
          .detail-label {
            font-weight: 500;
            color: #7A0C2E;
          }
          .detail-value {
            font-weight: 600;
            color: #333333;
          }
          .bank-details {
            background-color: #f0f8ff;
            border: 1px solid #2196f3;
            border-radius: 8px;
            padding: 20px;
            margin: 25px 0;
          }
          .bank-title {
            margin: 0 0 15px 0;
            font-size: 16px;
            font-weight: 600;
            color: #1976d2;
          }
          .bank-info {
            margin: 8px 0;
            font-size: 14px;
            color: #555555;
          }
          .bank-number {
            font-family: 'Courier New', monospace;
            font-weight: 600;
            background-color: #ffffff;
            padding: 8px;
            border-radius: 4px;
            border: 1px solid #e0e0e0;
          }
          .footer {
            background-color: #f5f5f5;
            padding: 25px 30px;
            text-align: center;
            border-top: 1px solid #e5e5e5;
          }
          .footer p {
            margin: 0 0 5px 0;
            font-size: 12px;
            color: #888888;
          }
        </style>
      </head>
      <body>
        <div class="email-container">
          <div class="header">
            <img src="https://sovozmianylokatorskie-xhjm5qczqq-ew.a.run.app/sovo_logo.png" alt="SOVO Development" style="height: 50px; width: auto; margin: 0 auto; display: block;">
          </div>

          <div class="content">
            <h2 class="greeting">Witaj ${customerName}!</h2>

            <div class="info-box">
              <p>📢 <strong>Etap ${stageNumber} inwestycji został zakończony</strong></p>
            </div>

            <p class="text-block">
              Informujemy, że <strong>etap ${stageNumber}</strong> budowy Twojego lokalu <strong>${apartmentCode}</strong> został zakończony.
              Zgodnie z harmonogramem płatności, <strong>rata nr ${installmentNumber}</strong> jest teraz wymagalna.
            </p>

            <p class="text-block" style="background-color: #fff3e0; padding: 15px; border-radius: 6px; border-left: 4px solid #ff9800;">
              <strong>Termin płatności: ${formattedPaymentDueDate}</strong> (7 dni od zakończenia etapu)
            </p>

            <div class="payment-details">
              <div class="detail-row">
                <span class="detail-label">Lokal:</span>
                <span class="detail-value">${apartmentCode}</span>
              </div>
              <div class="detail-row">
                <span class="detail-label">Numer umowy:</span>
                <span class="detail-value">${contractNumber}</span>
              </div>
              <div class="detail-row">
                <span class="detail-label">Zakończony etap:</span>
                <span class="detail-value">Etap ${stageNumber}</span>
              </div>
              <div class="detail-row">
                <span class="detail-label">Rata:</span>
                <span class="detail-value">${installmentNumber}</span>
              </div>
              <div class="detail-row">
                <span class="detail-label">Data zakończenia etapu:</span>
                <span class="detail-value">${today}</span>
              </div>
              <div class="detail-row">
                <span class="detail-label">Termin płatności:</span>
                <span class="detail-value" style="color: #e65100; font-weight: bold;">${formattedPaymentDueDate}</span>
              </div>
              <div class="detail-row">
                <span class="detail-label">Kwota do zapłaty:</span>
                <span class="detail-value" style="color: #1976d2; font-size: 18px;">${formatCurrency(dueAmount)}</span>
              </div>
            </div>

            <div class="bank-details">
              <h3 class="bank-title">💳 Dane do przelewu</h3>
              <div class="bank-info">
                <strong>Nazwa odbiorcy:</strong> SOVO Development Sp. z o.o.
              </div>
              <div class="bank-info">
                <strong>Numer konta:</strong>
                <div class="bank-number">12 3456 7890 1234 5678 9012 3456</div>
              </div>
              <div class="bank-info">
                <strong>Tytuł przelewu:</strong> ${contractNumber} - Rata ${installmentNumber} - ${apartmentCode}
              </div>
            </div>

            <p class="text-block">
              <strong>Prosimy o dokonanie płatności w najbliższym możliwym terminie.</strong>
            </p>

            <p class="text-block">
              W przypadku pytań lub problemów z płatnością, prosimy o kontakt z naszym działem finansowym.
            </p>

            <p class="text-block">
              Z poważaniem,<br>
              <strong>Dział Finansowy SOVO Development</strong>
            </p>
          </div>

          <div class="footer">
            <p>Wiadomość automatyczna z systemu SOVO Development</p>
            <p>Kontakt: finanse@sovo.dev | Tel: +48 XXX XXX XXX</p>
          </div>
        </div>
      </body>
      </html>
    `,
    text: `
Witaj ${customerName}!

📢 ETAP ${stageNumber} INWESTYCJI ZOSTAŁ ZAKOŃCZONY

Informujemy, że etap ${stageNumber} budowy Twojego lokalu ${apartmentCode} został zakończony.
Zgodnie z harmonogramem płatności, rata nr ${installmentNumber} jest teraz wymagalna.

TERMIN PŁATNOŚCI: ${formattedPaymentDueDate} (7 dni od zakończenia etapu)

SZCZEGÓŁY PŁATNOŚCI:
- Lokal: ${apartmentCode}
- Numer umowy: ${contractNumber}
- Zakończony etap: Etap ${stageNumber}
- Rata: ${installmentNumber}
- Data zakończenia etapu: ${today}
- Termin płatności: ${formattedPaymentDueDate}
- Kwota do zapłaty: ${formatCurrency(dueAmount)}

DANE DO PRZELEWU:
Nazwa odbiorcy: SOVO Development Sp. z o.o.
Numer konta: 12 3456 7890 1234 5678 9012 3456
Tytuł przelewu: ${contractNumber} - Rata ${installmentNumber} - ${apartmentCode}

Prosimy o dokonanie płatności w najbliższym możliwym terminie.

W przypadku pytań lub problemów z płatnością, prosimy o kontakt z naszym działem finansowym.

Z poważaniem,
Dział Finansowy SOVO Development

---
Wiadomość automatyczna z systemu SOVO Development
Kontakt: finanse@sovo.dev | Tel: +48 XXX XXX XXX
    `
  };
};

export const paymentConfirmationTemplate = ({
  customerName,
  apartmentCode,
  paidAmount,
  paymentDate,
  installmentNumber,
  contractNumber,
  invoiceNumber,
  remainingAmount = 0
}) => {
  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('pl-PL', {
      style: 'currency',
      currency: 'PLN'
    }).format(amount);
  };

  return {
    subject: `✅ Potwierdzenie płatności - Lokal ${apartmentCode} - Faktura ${invoiceNumber}`,
    html: `
      <!DOCTYPE html>
      <html lang="pl">
      <head>
        <meta charset="utf-8">
        <meta name="viewport" content="width=device-width, initial-scale=1.0">
        <title>Potwierdzenie płatności - SOVO Development</title>
        <style>
          body {
            margin: 0;
            padding: 0;
            font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Helvetica Neue', Arial, sans-serif;
            line-height: 1.6;
            color: #333333;
            background-color: #f5f5f5;
          }
          .email-container {
            max-width: 600px;
            margin: 0 auto;
            background-color: #ffffff;
          }
          .header {
            background-color: #ffffff;
            padding: 25px 20px;
            text-align: center;
            border-bottom: 1px solid #e5e5e5;
          }
          .content {
            padding: 35px 30px;
          }
          .greeting {
            margin: 0 0 20px 0;
            font-size: 22px;
            font-weight: 600;
            color: #7A0C2E;
          }
          .text-block {
            margin: 0 0 20px 0;
            font-size: 15px;
            color: #555555;
            line-height: 1.7;
          }
          .success-box {
            background-color: #e8f5e9;
            border-left: 4px solid #4caf50;
            padding: 18px 20px;
            margin: 25px 0;
            border-radius: 4px;
          }
          .success-box p {
            margin: 0;
            font-size: 15px;
            color: #2e7d32;
            line-height: 1.6;
            font-weight: 600;
          }
          .payment-summary {
            background-color: #f9f9f9;
            border-radius: 8px;
            padding: 25px;
            margin: 25px 0;
          }
          .summary-title {
            margin: 0 0 20px 0;
            font-size: 18px;
            font-weight: 600;
            color: #7A0C2E;
          }
          .detail-row {
            display: flex;
            justify-content: space-between;
            margin-bottom: 12px;
            padding-bottom: 8px;
            border-bottom: 1px solid #e0e0e0;
          }
          .detail-row:last-child {
            border-bottom: none;
            margin-bottom: 0;
          }
          .detail-label {
            font-weight: 500;
            color: #555555;
          }
          .detail-value {
            font-weight: 600;
            color: #333333;
          }
          .amount-highlight {
            background-color: #e8f5e9;
            border-radius: 6px;
            padding: 15px 20px;
            margin: 20px 0;
            text-align: center;
          }
          .amount-text {
            margin: 0;
            font-size: 24px;
            font-weight: 700;
            color: #2e7d32;
          }
          .attachment-info {
            background-color: #fff3e0;
            border: 1px solid #ffb74d;
            border-radius: 8px;
            padding: 20px;
            margin: 25px 0;
          }
          .attachment-title {
            margin: 0 0 10px 0;
            font-size: 16px;
            font-weight: 600;
            color: #e65100;
          }
          .attachment-text {
            margin: 0;
            font-size: 14px;
            color: #bf360c;
          }
          .next-payment {
            background-color: #f3e5f5;
            border-radius: 8px;
            padding: 20px;
            margin: 25px 0;
          }
          .next-title {
            margin: 0 0 10px 0;
            font-size: 16px;
            font-weight: 600;
            color: #7A0C2E;
          }
          .footer {
            background-color: #f5f5f5;
            padding: 25px 30px;
            text-align: center;
            border-top: 1px solid #e5e5e5;
          }
          .footer p {
            margin: 0 0 5px 0;
            font-size: 12px;
            color: #888888;
          }
        </style>
      </head>
      <body>
        <div class="email-container">
          <div class="header">
            <img src="https://sovozmianylokatorskie-xhjm5qczqq-ew.a.run.app/sovo_logo.png" alt="SOVO Development" style="height: 50px; width: auto; margin: 0 auto; display: block;">
          </div>

          <div class="content">
            <h2 class="greeting">Witaj ${customerName}!</h2>

            <div class="success-box">
              <p>✅ <strong>Płatność została pomyślnie zaksięgowana</strong></p>
            </div>

            <p class="text-block">
              Dziękujemy za dokonaną płatność za lokal <strong>${apartmentCode}</strong>. Środki zostały zaksięgowane na Twoim koncie.
            </p>

            <div class="payment-summary">
              <h3 class="summary-title">📋 Podsumowanie płatności</h3>
              <div class="detail-row">
                <span class="detail-label">Lokal:</span>
                <span class="detail-value">${apartmentCode}</span>
              </div>
              <div class="detail-row">
                <span class="detail-label">Numer umowy:</span>
                <span class="detail-value">${contractNumber}</span>
              </div>
              <div class="detail-row">
                <span class="detail-label">Rata:</span>
                <span class="detail-value">${installmentNumber}</span>
              </div>
              <div class="detail-row">
                <span class="detail-label">Data wpłaty:</span>
                <span class="detail-value">${paymentDate}</span>
              </div>
              <div class="detail-row">
                <span class="detail-label">Numer faktury:</span>
                <span class="detail-value">${invoiceNumber}</span>
              </div>
            </div>

            <div class="amount-highlight">
              <p class="amount-text">${formatCurrency(paidAmount)}</p>
              <p style="margin: 5px 0 0 0; font-size: 14px; color: #2e7d32;">Kwota zaksięgowana</p>
            </div>

            <div class="attachment-info">
              <h3 class="attachment-title">📎 Faktura w załączniku</h3>
              <p class="attachment-text">
                Faktura nr ${invoiceNumber} została załączona do tej wiadomości. Zachowaj ją jako potwierdzenie płatności.
              </p>
            </div>

            ${remainingAmount > 0 ? `
            <div class="next-payment">
              <h3 class="next-title">📅 Następna płatność</h3>
              <p style="margin: 0; font-size: 14px; color: #555555;">
                Pozostała kwota do zapłaty: <strong>${formatCurrency(remainingAmount)}</strong><br>
                Szczegóły kolejnych rat znajdziesz w harmonogramie płatności.
              </p>
            </div>
            ` : `
            <div class="success-box">
              <p>🎉 <strong>Gratulacje! Wszystkie raty zostały opłacone</strong></p>
            </div>
            `}

            <p class="text-block">
              <strong>Masz pytania?</strong><br>
              W razie jakichkolwiek pytań dotyczących płatności, skontaktuj się z naszym działem finansowym.
            </p>

            <p class="text-block">
              Dziękujemy za terminowe regulowanie zobowiązań!<br>
              <strong>Zespół SOVO Development</strong>
            </p>
          </div>

          <div class="footer">
            <p>Wiadomość automatyczna z systemu SOVO Development</p>
            <p>Kontakt: finanse@sovo.dev | Tel: +48 XXX XXX XXX</p>
          </div>
        </div>
      </body>
      </html>
    `,
    text: `
Witaj ${customerName}!

✅ PŁATNOŚĆ ZOSTAŁA POMYŚLNIE ZAKSIĘGOWANA

Dziękujemy za dokonaną płatność za lokal ${apartmentCode}. Środki zostały zaksięgowane na Twoim koncie.

PODSUMOWANIE PŁATNOŚCI:
- Lokal: ${apartmentCode}
- Numer umowy: ${contractNumber}
- Rata: ${installmentNumber}
- Data wpłaty: ${paymentDate}
- Numer faktury: ${invoiceNumber}
- Kwota zaksięgowana: ${formatCurrency(paidAmount)}

FAKTURA W ZAŁĄCZNIKU:
Faktura nr ${invoiceNumber} została załączona do tej wiadomości. Zachowaj ją jako potwierdzenie płatności.

${remainingAmount > 0 ? `NASTĘPNA PŁATNOŚĆ:
Pozostała kwota do zapłaty: ${formatCurrency(remainingAmount)}
Szczegóły kolejnych rat znajdziesz w harmonogramie płatności.` : 
`🎉 GRATULACJE! Wszystkie raty zostały opłacone.`}

Masz pytania?
W razie jakichkolwiek pytań dotyczących płatności, skontaktuj się z naszym działem finansowym.

Dziękujemy za terminowe regulowanie zobowiązań!
Zespół SOVO Development

---
Wiadomość automatyczna z systemu SOVO Development
Kontakt: finanse@sovo.dev | Tel: +48 XXX XXX XXX
    `
  };
};

// --- Change Request templates (internal, admin-facing) ---

export const changeRequestSubmittedTemplate = ({
  requestedByEmail,
  flatCode,
  paymentNumber,
  changes,
  note,
}) => {
  const changeRows = Object.entries(changes)
    .map(([field, { from, to }]) => `${field}: ${from || '(brak)'} -> ${to || '(brak)'}`)
    .join('\n');

  return {
    subject: `Nowy wniosek o zmiane - Lokal ${flatCode}, Rata ${paymentNumber}`,
    text: `Nowy wniosek o zmiane harmonogramu.\n\nLokal: ${flatCode}\nRata: ${paymentNumber}\nZgloszono przez: ${requestedByEmail}\n\nZmiany:\n${changeRows}\n\nUzasadnienie: ${note || '(brak)'}\n\nZaloguj sie do SOVO Pay aby zatwierdzic lub odrzucic.`,
    html: '',
  };
};

export const changeRequestResolvedTemplate = ({
  flatCode,
  paymentNumber,
  status,
  rejectionReason,
}) => {
  const statusText = status === 'approved' ? 'ZATWIERDZONY' : 'ODRZUCONY';
  return {
    subject: `Wniosek ${statusText} - Lokal ${flatCode}, Rata ${paymentNumber}`,
    text: `Twoj wniosek o zmiane harmonogramu dla lokalu ${flatCode}, rata ${paymentNumber} zostal ${statusText.toLowerCase()}.\n\n${rejectionReason ? `Powod odrzucenia: ${rejectionReason}` : ''}`,
    html: '',
  };
};